import React from "react";
import { ScaleLoader } from "react-spinners";

const Loader = ({ isLoading }) => {
  if (!isLoading) return null;

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 9999,
      }}
    >
      <div>
        <ScaleLoader color="#FFF" loading={true} height={30} />
      </div>
    </div>
  );
};

export default Loader;
